module.exports = __webpack_public_path__ + "img/github.5cff78e4.svg";